/**
 * @copyright 2026 Cooltrax Pty Ltd. All rights reserved.
 */
import React, { ReactNode } from 'react'

import { MdSignalWifiConnectedNoInternet0 } from 'react-icons/md'

import AssetTableCell from './AssetTableCell'
import { formatDate12, getDoorMpColMeta, joinStrings, timeSinceFormatted } from './utils'

type DoorMpColProps = {
  value: string
  onlineSampleTime: Date
  tagSampleTime: Date
  tagOnline: boolean
  gatewayOn: boolean
}

const DoorMpCol: React.FC<DoorMpColProps> = ({ value, tagSampleTime, tagOnline, gatewayOn, onlineSampleTime }) => {
  const { isValueBlank, displayBlank, displayMissing } = getDoorMpColMeta(gatewayOn, tagOnline, value)

  const lastValue = isValueBlank ? '<No reading>' : value

  const timeAgo = displayMissing ? '' : ` ${timeSinceFormatted(tagSampleTime)}`
  const statusChangedString = tagSampleTime ? `Status changed at ${formatDate12(tagSampleTime)}${timeAgo}` : ''
  const offlineSinceString = onlineSampleTime
    ? `Offline since ${formatDate12(onlineSampleTime)} ${timeSinceFormatted(onlineSampleTime)}`
    : ''
  const lastValueString = `Last value: ${lastValue}`

  let tooltip = statusChangedString
  let displayValue: ReactNode = <div className="h-4 w-full flex"></div>
  if (displayBlank) {
    tooltip = joinStrings(statusChangedString, lastValueString)
  } else if (displayMissing) {
    tooltip = joinStrings('No data available', statusChangedString, offlineSinceString, lastValueString)
    displayValue = <MdSignalWifiConnectedNoInternet0 className="w-4 h-4 text-gray-500" />
  } else {
    displayValue = value
  }

  return <AssetTableCell tooltip={tooltip}>{displayValue}</AssetTableCell>
}

export default DoorMpCol
